import { IConfig } from '@cian/config/shared';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';

import { Store } from 'redux';

import { IAppState } from '../../../../shared/redux';
import { IOfferHomeowner } from '../../../../shared/redux/reducers';
import { getUserCanPublishAsCommercialOwner } from '../../../../shared/services/commercialOwner';

import { IAddFormService } from './addFormService';
import { ICoworkingService } from './coworking.service';
import { IHomeownerService } from './homeownerService';

import { ICommercialOwnerService } from './commercialOwnerService';

export const commercialOwnerService = [
  'httpApi',
  'logger',
  'store',
  'addFormService',
  'coworkingService',
  'homeownerService',
  /**
   * @todo Удалить строку с RS
   * @description Данный функционал появился в задаче CD-133253, будет удалён в задаче CD-133562
   */
  'config',
  (
    httpApi: IHttpApi,
    logger: ILogger,
    store: Store<IAppState>,
    addFormService: IAddFormService,
    coworkingService: ICoworkingService,
    homeownerService: IHomeownerService,
    /**
     * @todo Удалить строку с RS
     * @description Данный функционал появился в задаче CD-133253, будет удалён в задаче CD-133562
     */
    config: IConfig,
  ): ICommercialOwnerService => {
    const service = {} as ICommercialOwnerService;

    service.canPublishAsCommercialOwner = async () => {
      const { canPostAsOwner } = await getUserCanPublishAsCommercialOwner({
        httpApi,
        logger,
        parameters: { offerId: addFormService.getFieldValue('id') },
      });

      return canPostAsOwner;
    };

    service.changeUserCanPublishAsCommercialOwner = canPublishAsCommercialOwner => {
      // TODO: вынести этот метод из сервиса homeowner, будет поправлено тут COMM-340
      homeownerService.setUserCanPublishAsCommercialOwner(canPublishAsCommercialOwner);

      const isByCommercialOwnerPrev = addFormService.getFieldValue('isByCommercialOwner');
      const isByCommercialOwner = canPublishAsCommercialOwner && isByCommercialOwnerPrev;

      addFormService.setValueByPath('isByCommercialOwner', isByCommercialOwner);

      if (!isByCommercialOwner) {
        service.clearHomeowner();
      }
    };

    /**
     * @todo Удалить метод с RS
     * @description Данный функционал появился в задаче CD-133253, будет удалён в задаче CD-133562
     * @deprecated
     */
    service.isUserCommercialOwnerByAgentAccountType = () => {
      const state = store.getState();
      const agentAccountType = state.user.agentAccountType;

      return ['managementCompany', 'rentDepartment'].includes(agentAccountType);
    };

    service.isCommercialObjectTypeWithVerification = objectType => {
      return [
        'office',
        'building',
        'shoppingArea',
        'freeAppointmentObject',
        'industry',
        'warehouse',
        'commercialLand',
      ].includes(objectType);
    };

    service.isCommercialOwnerWidgetVisible = objectType => {
      const isByCommercialOwner = addFormService.getFieldValue('isByCommercialOwner');

      const commercialOwnerV2Enabled = config.get<boolean>('Commercial.Owner.v2.Enabled');

      /**
       * @todo Удалить ветвление с RS
       * @description Данный функционал появился в задаче CD-133253, будет удалён в задаче CD-133562
       */
      if (!commercialOwnerV2Enabled) {
        const isUserWithCommercialOwnership = service.isUserCommercialOwnerByAgentAccountType();

        if (!isByCommercialOwner || isUserWithCommercialOwnership) {
          return false;
        }

        return service.isCommercialObjectTypeWithVerification(objectType);
      }

      if (!isByCommercialOwner) {
        return false;
      }

      return service.isCommercialObjectTypeWithVerification(objectType);
    };

    service.shouldRosreestCaptionVisible = () => {
      const isByCommercialOwner = !!addFormService.getFieldValue<boolean>('isByCommercialOwner');
      const homeOwner = !!addFormService.getFieldValue<IOfferHomeowner>('homeOwner');

      return isByCommercialOwner && homeOwner;
    };

    const categoriesWithoutHomeOwner = ['garageSale', 'garageRent', 'businessSale', 'businessRent'];

    service.isCommercialCategoryWithoutHomeowner = category => {
      return categoriesWithoutHomeOwner.includes(category) || coworkingService.isCoworkingCategory();
    };

    service.clearHomeowner = () => {
      addFormService.setValueByPath('homeOwner', undefined);
    };

    return service;
  },
];
